import {SearchApiRequestTypes} from "../../config/constants"
import {Facets} from "../Facet"
import {SearchCategory} from "../SearchCategory"
import {FilterApiResponse, Filters} from "../Filter"
import {ProductItem} from "../Product"
import {Pagination} from "../Pagination"
import {Sorting} from "../Sorting"
import {TemplateOverride} from "../SearchState"

export class KeywordRedirect {
    redirectedUrl = ""
    redirectedQuery = ""
    originalQuery = ""
}

export class ExternalSearchApiResponse {
    totalResults!: number
    redirect: any
    filters: FilterApiResponse[] | null = null
    items: ProductItem[] = []
    pagination: Pagination = new Pagination()
    keywordRedirect: KeywordRedirect = new KeywordRedirect()
    sorting: Sorting = new Sorting()
    title = ""
    autoCorrectQuery = ""
    relaxedQuery = ""
    includedComponents?: string[] = []
    templateOverride?: TemplateOverride = {}
    searchCategory?: SearchCategory = {id: "", name: ""}
    saleDisplayText?: string
    searchProviderRequestUrl?: string
    searchBanner?: string | null
    searchSource = ""
}

export class ExternalSearchApiRedirectResponse {
    redirectUrl!: string
}

export type ExternalGenericSearchApiResponse = ExternalSearchApiResponse | ExternalSearchApiRedirectResponse

export type pageLoadTriggerType = "PREVIOUS" | "NEXT" | "FILTER"
export class ExternalSearchApiRequest {
    criteria = ""
    providerArgs = ""
    start = 0
    pagesize = 0
    contextid = ""
    type: SearchApiRequestTypes = SearchApiRequestTypes.Category
    fields: string | null = null
    segment = ""
    pageLoadTrigger = ""
    sliceSize = 12
    productSummaryTemplateName?: string = ""
    imageRatio?: string = ""
}

export class SearchApiRequest extends ExternalSearchApiRequest {
    searchTerm = ""
    showSearchProviderRequestUrl = false
}

export class SearchApiResponse {
    totalResults!: number
    facets: Facets = {}
    filtersSort: string[] = []
    filters: Filters = {}
    items: ProductItem[] = []
    sorting: Sorting = new Sorting()
    title = ""
    autoCorrectQuery: string | null = ""
    relaxedQuery = ""
    includedComponents: string[] = []
    templateOverride?: {
        [key in `${string}TemplateName`]: string
    } & {imageRatio?: string} = {}

    searchCategory: SearchCategory = {id: "", name: ""}
    saleDisplayText?: string
    searchProviderRequestUrl?: string
    searchBannerJson?: string | null
    searchSource = ""
}

export class RedirectResponse {
    statusCode!: number
    url!: string
}

export type GenericSearchResponse = SearchApiResponse | RedirectResponse
